import { Anchor } from '@mantine/core';
import { useIntl } from 'react-intl';

import { freightFormMessages } from './freight-form-messages';
import styles from './ShipFromSection.module.css';
import { Dropdown } from '../../../common/Dropdown';

import type { ShipFromOption } from '../../freight-browser-types';

type ShipFromSectionProps = {
  value: string;
  onChange: (id: string) => void;
  options: ShipFromOption[];
  onAddShipFrom?: () => void;
};

export const ShipFromSection = ({ value, onChange, options, onAddShipFrom }: ShipFromSectionProps) => {
  const intl = useIntl();

  const selectData = options.map((opt) => ({ value: opt.id, label: opt.name }));

  const handleChange = (val: string | null) => {
    if (val) onChange(val);
  };

  return (
    <div>
      <div className={styles.fieldLabelRow}>
        <span className={styles.fieldLabel}>
          {intl.formatMessage(freightFormMessages.shipFromLabel)}
          <span aria-hidden className={styles.asterisk}>
            {' '}
            *
          </span>
        </span>
        {onAddShipFrom && (
          <Anchor className={styles.addLink} component='button' onClick={onAddShipFrom} size='sm' type='button'>
            {intl.formatMessage(freightFormMessages.addShipFrom)}
          </Anchor>
        )}
      </div>
      <Dropdown
        data={selectData}
        onChange={handleChange}
        placeholder={intl.formatMessage(freightFormMessages.shipFromPlaceholder)}
        value={value || null}
      />
    </div>
  );
};
